import axios from 'axios'
import { url } from './global'


export const createArticuloPrecio = async (data) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    const res = await axios.post(`${url}/v2/articulos/precios`, data, {
        headers,
    })
    return res
}

export const updateArticuloPrecio = async (articuloId, listaId, data) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    const res = await axios.put(`${url}/v2/articulos/precios/${articuloId}/lista/${listaId}`, data, {
        headers,
    })
    return res
}

export const deleteArticuloPrecio = async (articuloId, listaId) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    const res = await axios.delete(`${url}/v2/articulos/precios/${articuloId}/lista/${listaId}`, {
        headers,
    })
    return res
}

export const importArticuloPrecio = async (data) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'multipart/file',
        Authorization: 'Bearer '.concat(token),
    }
    const res = await axios.post(`${url}/v2/articulos/precios/importar`, data, {
        headers,
    })
    return res
}

export const getAllArticuloPrecio = async (activo, page, lista, nombre = '', size = 50) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    const res = await axios.get(`${url}/v2/articulos/precios?${nombre ? `nombre=${nombre}&` : ''}listaPrecio=${lista}&activo=${activo}&page=${page}&size=${size}`, { headers });
    return res
}
